
import React from 'react';
import { StepStage } from '../types';
import { CheckCircle, Circle, Loader2 } from 'lucide-react';

interface Props {
  currentStage: StepStage;
}

const steps = [
  { id: StepStage.INIT, label: '初始化' },
  { id: StepStage.MARKET_INTEL, label: '市场侦察' },
  { id: StepStage.PERSONA_GRAVITY, label: '客群画像' },
  { id: StepStage.PRICING_GAME, label: '双轨定价' },
  { id: StepStage.PRODUCT_STRATEGY, label: '产品策略' },
  { id: StepStage.DESIGN_BRIEF, label: '设计任务' },
  { id: StepStage.DESIGN_VALIDATION, label: '方案博弈' },
  { id: StepStage.FINANCIAL_MODEL, label: '经营测算' },
  { id: StepStage.FINAL_REPORT, label: '总结备忘' },
];

export const StepIndicator: React.FC<Props> = ({ currentStage }) => {
  return (
    <div className="w-full bg-white border-b border-gray-200 py-4 px-6 overflow-x-auto">
      <div className="flex items-center min-w-max space-x-4">
        {steps.map((step) => {
          const isCompleted = step.id < currentStage;
          const isCurrent = step.id === currentStage;

          return (
            <div key={step.id} className="flex items-center">
              <div className={`flex items-center space-x-2 ${isCurrent ? 'text-blue-600' : isCompleted ? 'text-green-600' : 'text-gray-400'}`}>
                {isCompleted ? (
                  <CheckCircle size={20} />
                ) : isCurrent ? (
                  <Loader2 size={20} className="animate-spin" />
                ) : (
                  <Circle size={20} />
                )}
                <span className={`text-sm font-medium ${isCurrent ? 'font-bold' : ''}`}>
                  {step.label}
                </span>
              </div>
              {step.id !== StepStage.FINAL_REPORT && (
                <div className={`w-8 h-0.5 ml-4 ${isCompleted ? 'bg-green-50' : 'bg-gray-200'}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
